












import { Component, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import DocumentSheet from '@/components/DocumentSheet.vue'  // @ is an alias to /src
import { Voucher } from '@/services/models'

@Component({
  components: {
    DocumentSheet,
  },
})
export default class VoucherSheet extends Vue {

  @Action('firestore/fetchVoucher')
  private fetchVouchers!: () => Promise<void>

  @Getter('firestore/voucher')
  private readVoucher!: (voucherId: string) => Voucher|undefined

  // Loading status
  private issuingVoucher: boolean|Error = true

  private get voucher(): Voucher|undefined {
    return this.readVoucher(this.voucherId)
  }

  private get voucherId(): string {
    return this.$route.params.voucher_id
  }

  public mounted() {
    this.issuingVoucher = true
    this.fetchVouchers()
      .then(() => {
        this.issuingVoucher = false
      })
      .catch((error) => {
        this.issuingVoucher = error
      })
  }
}
